import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getParamConfigMaterialSearch = createApi(`ParamConfigSearchMaterialSlice`,"POST");

const ParamConfigSearchMaterialSlice = createSlice({
  name: 'ParamConfigSearchMaterialSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getParamConfigMaterialSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getParamConfigMaterialSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getParamConfigMaterialSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ParamConfigSearchMaterialSlice.reducer;